import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import ObjectTopBar from '../components/topbar/ObjectTopBar';
import useDocumentTitle from '../../shared/hooks/useDocumentTitle.js';
import WorkspaceView, { WorkspaceScroll } from '../components/layout/WorkspaceView';
import AiTabs from '../components/ai/AiTabs';
import AiSettingsPanel from '../components/ai/AiSettingsPanel';
import AiIndexingPanel from '../components/ai/AiIndexingPanel';
import AiTestingPanel from '../components/ai/testing/AiTestingPanel';

// Every tab renders inside the same WorkspaceView frame, so the tab bar occupies one fixed
// position regardless of which tab is open. `panels` only says whether the body is a set of
// columns or a scrolling document — it never changes the frame around them.
const AI_TABS = [
  {
    slug: 'field-engineer',
    label: 'Field engineer',
    icon: 'bi-person-gear',
    title: 'Field engineer prompt',
    render: () => <AiSettingsPanel persona="field_engineer" />,
  },
  {
    slug: 'workflow',
    label: 'Workflow creation',
    icon: 'bi-diagram-3',
    title: 'Workflow creation prompt',
    render: () => <AiSettingsPanel persona="workflow" />,
  },
  {
    slug: 'indexing',
    label: 'Indexing',
    icon: 'bi-hdd-stack',
    title: 'AI indexing status',
    panels: true,
    render: () => <AiIndexingPanel />,
  },
  {
    slug: 'testing',
    label: 'Testing',
    icon: 'bi-beaker',
    title: 'AI testing',
    panels: true,
    render: () => <AiTestingPanel />,
  },
];

const DEFAULT_AI_TAB = AI_TABS[0].slug;

export default function OrganizationAiPage() {
  const { tab } = useParams();
  const active = AI_TABS.find((t) => t.slug === tab);

  useDocumentTitle(`${active ? active.title : 'AI'} – AI – Maintella`);

  // An unknown or missing slug redirects rather than rendering an empty shell, so a stale
  // bookmark lands somewhere useful instead of on a blank tab body.
  if (!active) {
    return <Navigate to={`/admin/organization/ai/${DEFAULT_AI_TAB}`} replace />;
  }

  return (
    <>
      <ObjectTopBar title="AI" />
      <WorkspaceView toolbar={<AiTabs tabs={AI_TABS} />}>
        {active.panels ? (
          active.render()
        ) : (
          <WorkspaceScroll readable>{active.render()}</WorkspaceScroll>
        )}
      </WorkspaceView>
    </>
  );
}
